"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.supportedGoerliERC20 = void 0;
// List of the supported goerli ERC20 tokens
exports.supportedGoerliERC20 = {
    // Faucet Token on goerli network.
    '0xBA62BCfcAaFc6622853cca2BE6Ac7d845BC0f2Dc': {
        decimals: 18,
        name: 'FaucetToken',
        symbol: 'FAU',
    },
};
